import FormComponent from '../utils/FormComponent';
import * as blockUtils from '../../utils/BlockUtils';
import * as api from '../../api/audit-api';
import i18next from 'i18next';
import ModalDialog from '../utils/ModalDialog';
import ReduxDataTable from '../redux_data_table/ReduxDataTable';
import BooleanLabel from '../utils/BooleanLabel';
import PropTypes from 'prop-types';
import {React} from 'react';
import Status from '../utils/Status';

class SiteAuditForm extends FormComponent {
  constructor(props) {
    super(props);

    this.getSiteHistory = this.getSiteHistory.bind(this);

    this.pageNumber = 0;
    this.elementsCount = 10;
    this.sortingName = 'revision';
    this.sortingType = 'DESC';
    this.searchPhrase = '';
  }

  initialState() {
    return {
      siteId: this.props.siteId,
      records: [],
      totalElements: 0,
      totalPages: 0,
      dialogId: this.props.dialogId,
      tableId: this.props.tableId,
    };
  }

  componentDidMount() {
    this.getSiteHistory();
  }

  getSiteHistory(
      pageNumber = this.pageNumber,
      elementsCount = this.elementsCount,
      sortingName = this.sortingName,
      sortingType = this.sortingType,
      searchPhrase = this.searchPhrase,
  ) {
    const data = {
      page: pageNumber,
      size: elementsCount,
      query: searchPhrase,
      sort: `${sortingName},${sortingType.toLowerCase()}`,
    };

    blockUtils.blockUI();
    api.getAuditRecordsForSite(this.props.siteId, data).then((response) => {
      blockUtils.unblockUI();
      this.setState({
        records: response.data.content,
        totalElements: response.data.totalElements,
        totalPages: response.data.totalPages,
      });
    }).catch((error) => {
      blockUtils.unblockUI();
      window.showAlert(i18next.t('error'), error.response.data.errorMessage);
    });
  }

  render() {
    return (
      <ModalDialog
        customClass="site-history-form"
        modalTitle={i18next.t('audit.site.title', {siteId: this.state.siteId})}
        dialogId={this.props.dialogId}
        onDialogHide={blockUtils.unblockUI}
        onDialogShown={this.onFormShow}
        showSave={false}
        customStyle={{'width': '90%'}}
      >

        <div className="table-container">
          <ReduxDataTable
            {...this.state}
            hideSearch={true}
            getData={this.getSiteHistory}
            columnCount={1}
          >
            <thead>
              <tr role="row" className="heading">
                <th>{i18next.t('sites.attrs.name')}</th>
                <th>Timestamp</th>
                <th>RevType</th>
                <th>Username</th>
                <th>{i18next.t('users.attrs.language')}</th>
                <th>{i18next.t('sites.attrs.siteType')}</th>
                <th>{i18next.t('sites.attrs.contact_email')}</th>
                <th>{i18next.t('sites.attrs.token')}</th>
                <th>{i18next.t('sites.attrs.app_technology')}</th>
                <th>Gateway ID</th>
                <th>HMS Version</th>
                <th>{i18next.t('sites.attrs.alerts')}</th>
                <th width="1%">{i18next.t('sites.attrs.status')}</th>
                <th width="1%">{i18next.t('sites.attrs.hms_connected')}</th>
                <th>{i18next.t('sites.attrs.enabled')}</th>
              </tr>
            </thead>
            <tbody>
              {this.state.records.map((site) => {
                return (
                  <tr key={site.rev}>
                    <td>{site.name}</td>
                    <td>{site.timestamp}</td>
                    <td>{site.revType}</td>
                    <td>{site.username}</td>
                    <td>{site.language === 'en' ? 'English' : 'Deutsch'}</td>
                    <td>{site.siteType}</td>
                    <td>{site.contactEmail}</td>
                    <td>{site.token}</td>
                    <td>{site.appTechnology}</td>
                    <td>{site.gatewayId}</td>
                    <td>{site.siteAgentVersion}</td>
                    <td>
                      <BooleanLabel value={site.disconnectionNotifications} />
                    </td>
                    <td className="status-column">
                      <Status online={site.connected} />
                    </td>
                    <td className="status-column">
                      <Status online={site.hmsConnected} />
                    </td>
                    <td>
                      <BooleanLabel value={!site.disabled} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </ReduxDataTable>
        </div>
      </ModalDialog>
    );
  }
}

SiteAuditForm.propTypes = {
  siteId: PropTypes.number,
  records: PropTypes.array,
  dialogId: PropTypes.string,
  totalElements: PropTypes.number,
  totalPages: PropTypes.number,
  tableId: PropTypes.string,
};

export default SiteAuditForm;
